import React, { useState } from 'react';
import { Box, Flex, HStack, IconButton, Image, Text, VStack } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { QuoteIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/content';
const MotionBox = motion(Box);
export function Testimonials() {
  const [active, setActive] = useState(0);
  const total = testimonials.length;
  const go = (direction: 1 | -1) => {
    setActive(current => (current + direction + total) % total);
  };
  return <Box as="section" id="experiencias" bg="cream.50" color="ink.900" position="relative" pt={{
    base: 16,
    md: 28
  }} pb={{
    base: 20,
    md: 28
  }} mt={{
    md: '-4vw'
  }} sx={{
    clipPath: {
      base: 'none',
      md: 'polygon(0 4vw, 100% 0, 100% 100%, 0 100%)'
    }
  }} data-id="element-218" data-mp="2x1uquj1b313z">
      <Box px={{
      base: 5,
      md: 10,
      xl: 16
    }} data-id="element-219" data-mp="qbeqn195u1d5">
        <Reveal data-id="element-220" data-mp="q8ixdq89c0v1">
          <SectionHeading eyebrow="Opiniones reales de consultas" title="Experiencias de nuestros clientes" description="Comentarios compartidos por personas que nos han consultado. Las experiencias son personales y los resultados pueden variar según cada persona." data-id="element-221" data-mp="h67wpwq6ta6o" />
        </Reveal>

        <Box position="relative" maxW="40rem" mx="auto" mt={{
        base: 12,
        md: 16
      }} h={{
        base: '23rem',
        md: '21rem'
      }} sx={{
        perspective: '1200px'
      }} data-id="element-222" data-mp="c7wnno7pv3pi">
          {testimonials.map((testimonial, index) => {
          let offset = index - active;
          if (offset < 0) offset += total;
          return <MotionBox key={testimonial.author} as="figure" position="absolute" inset={0} m={0} bg="white" border="1px solid" borderColor="cream.200" borderTop="3px solid" borderTopColor="crimson.500" px={{
            base: 6,
            md: 10
          }} py={{
            base: 7,
            md: 9
          }} boxShadow="0 24px 60px rgba(13,13,13,0.14)" cursor={offset === 0 ? 'pointer' : 'default'} onClick={() => offset === 0 && go(1)} drag={offset === 0 ? 'x' : false} dragConstraints={{
            left: 0,
            right: 0
          }} dragElastic={0.5} onDragEnd={(_, info) => {
            if (Math.abs(info.offset.x) > 80) go(info.offset.x < 0 ? 1 : -1);
          }} animate={{
            y: offset * 16,
            scale: 1 - offset * 0.05,
            opacity: offset > 2 ? 0 : 1 - offset * 0.18,
            zIndex: total - offset
          }} transition={{
            type: 'spring',
            stiffness: 140,
            damping: 20
          }} sx={{
            clipPath: 'polygon(0 0, 100% 0, 100% 90%, 93% 100%, 0 100%)'
          }} data-id="element-223" data-mp="v4xw5j0hbly7" data-mpi={index}>
                <VStack align="flex-start" spacing={5} h="100%" justify="space-between" data-id="element-224" data-mp="32fukhmf8yhj3">
                  <Box as={QuoteIcon} width="2rem" height="2rem" color="gold.400" aria-hidden="true" data-id="element-225" data-mp="37f7fwvk6owxa" />
                  <Text as="blockquote" fontFamily="heading" fontSize={{
                base: '1.35rem',
                md: '1.75rem'
              }} fontStyle="italic" lineHeight={1.35} color="ink.900" data-id="element-226" data-mp="3cg4xb5xddmxq">
                    “{testimonial.quote}”
                  </Text>
                  <HStack as="figcaption" spacing={4} data-id="element-227" data-mp="2sr46fc6xn33q">
                    <Image src={testimonial.avatar} alt={`Retrato de ${testimonial.author}`} w="3.25rem" h="3.25rem" borderRadius="full" objectFit="cover" border="2px solid" borderColor="gold.400" loading="lazy" data-id="element-228" data-mp="2spjgjzvkc8c7" />
                    <Box data-id="element-229" data-mp="1lukck1zr9gey">
                      <Text fontSize="sm" fontWeight={700} color="ink.900" data-id="element-230" data-mp="1gybxeolk5n7s">
                        {testimonial.author}
                      </Text>
                      <Text fontSize="xs" color="crimson.500" letterSpacing="0.14em" textTransform="uppercase" data-id="element-231" data-mp="1vo14f0gc0lfz">
                        {testimonial.meta}
                      </Text>
                    </Box>
                  </HStack>
                </VStack>
              </MotionBox>;
        })}
        </Box>

        <Flex justify="center" align="center" mt={8} gap={4} data-id="element-232" data-mp="29mr32kisut6g">
          <IconButton aria-label="Testimonio anterior" icon={<ChevronLeftIcon size={20} data-id="element-234" data-mp="k8cj0diq7uha" />} onClick={() => go(-1)} variant="crimsonOutline" borderRadius="full" size="lg" data-id="element-233" data-mp="29kekq694qgsv" />
          <Text fontSize="xs" letterSpacing="0.22em" textTransform="uppercase" color="ink.700" opacity={0.6} data-id="element-235" data-mp="2qvjwvnuo2tsh">
            {active + 1} / {total}
          </Text>
          <IconButton aria-label="Siguiente testimonio" icon={<ChevronRightIcon size={20} data-id="element-237" data-mp="2h5qkikmpaan6" />} onClick={() => go(1)} variant="crimsonOutline" borderRadius="full" size="lg" data-id="element-236" data-mp="2h60ai87qwhsv" />
        </Flex>
      </Box>
    </Box>;
}